<template>
  <ComboBox
    v-if="bots.length > 1"
    class="w-full"
    select-placeholder="Select Bot"
    search-placeholder="Search Bots..."
    empty-text="No Bots Found"
    variant="framed"
    :selected-item="currentBotId"
    :items="botItems"
    @update:selected-item="onChangeBot"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";
import ComboBox from "@/components/forms/ComboBox.vue";
import { useBotsStore } from "@/stores/bots";

const botsStore = useBotsStore();
const router = useRouter();

const bots = computed(() => botsStore.botsGetter);
const currentBotId = computed(() => botsStore.currentBotId);

const botItems = computed(() =>
  (bots.value as any[]).map((bot: any) => ({
    value: bot.uniqueBotId,
    label: bot.name,
  })),
);

function onChangeBot(uniqueBotId: any) {
  botsStore.changeBot({
    uniqueBotId,
    router,
  });
}
</script>
